import { useErrorHandler } from '../../context/ErrorBoundary';
import { useMsal } from '@azure/msal-react';
import NetworkErrorDialog from './NetworkErrorDialogue';
import { ReactComponent as PermissionIcon } from '../../assests/popupIcons/key_off.svg'; // Assuming you have an error icon SVG
import { ReactComponent as SessionIcon } from '../../assests/popupIcons/timer_off.svg'; // Assuming you have a lock icon SVG
import { ReactComponent as NetworkIcon } from '../../assests/popupIcons/signal_disconnected.svg'; // Assuming you have a lock icon SVG
import { useOnlineStatus } from '../../utils/UseOnlineStatus';
import { PageConfig } from '@configure/PathConfig';
import { validateAndRedirectStatus } from '@auth/loaders/validateAndRedirectStatus';
import ModalPopup from '@/components/ui/modalpopup';
import { Button } from '@/components/ui/button';
import { deleteWithLocalExpiry } from '@utils/index';

export const ErrorPopup = () => {
  const { error, setError } = useErrorHandler();
  const { instance } = useMsal();
  const isOnline = useOnlineStatus();

  const handleClose = () => {
    setError(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
      mainWindowRedirectUri: "/",
    });
    deleteWithLocalExpiry()
  };
  
  const handleNavigateProject = () => {
    try {
      window.location.href = `${PageConfig["PLAYGROUND"].PROJECTS}`;
    } catch (err) {
      console.error("Redirect failed", err);
    }
  };

const handleNavigateRoute = async () => {
  try {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    // Regex to match WAV123 or inab-123
    const regex = /^(WAV\d+|inab-\d+)$/;
    const demandIdRegex = /^\d+$/;
    // only numbers segment

    const dealid = pathSegments.find(seg => regex.test(seg)) || null;

    const demandid = pathSegments.find(seg => demandIdRegex.test(seg)) || null;
    console.log(dealid);
    const pathname = window.location.pathname;

    const newPath = await validateAndRedirectStatus({ pathname, dealid, demandid });

    if (newPath) {
      window.history.replaceState(null, '', '/');
      window.history.replaceState(null, '', newPath);
      window.dispatchEvent(new PopStateEvent('popstate'));
      handleClose();
    }else {
      // No valid path found — reload the page
      handleClose();
      window.location.reload();
    }

  } catch (error) {
    try {
      const err = JSON.parse(error.message);
      console.error("Handled Error:", err.message);
    } catch {
      console.error("Unknown Error:", error);
    }
  }
};
  if (!isOnline) {
    return (
      <NetworkErrorDialog
        open
        icon={<NetworkIcon />}
        title="No Internet Connection"
        message="You are currently offline. Please check your network connection."
        onRetry={() => window.location.reload()}
      />
    );
  }
  if (!error) return null;

  const { statusCode, status, errorType, data, stack } = error.response || error;
  const code = statusCode || status || 500;
  // 👉 Handle offline state


  // 👉 Handle 401, 403, and 409 with custom design
  if ([401, 403, 409].includes(code)) {
    let icon, title, message, onRetry;

    if (code === 401) {
      icon = <SessionIcon />;
      title = "Session Ended!";
      message = data?.message || "Your session has expired. Please log in again.";
      onRetry = handleLogout;
    } else if (code === 403) {
      icon = <PermissionIcon />;
      title = "Permission Denied";
      message = "You do not have the required permissions to access this resource or perform this action.";
      if(data?.message === `User doesn't have access to this workbook.` || data?.message === `User doesn't have access to this Project.`){
      onRetry = handleNavigateProject;
      }
      else if(data?.message === `You do not have permission to edit/update this deal.`){
        onRetry = () => window.location.reload()
      }
      else{
      onRetry = handleClose;
      }
    } else if (code === 409) {
      icon = <PermissionIcon />;
      title = "Conflict";
      message = data?.message || "A conflict occurred while processing your request.";
      onRetry = handleNavigateRoute;
    }

    return (
      <NetworkErrorDialog
        open
        icon={icon}
        title={title}
        message={message}
        onRetry={onRetry}
      />
    );
  }

// 👉 Generic modal for other errors (only in development)
if (process.env.NODE_ENV === "development") {
  const title = `Error ${code}`;
  const content = data?.message || 'An unexpected error occurred.';

  return (
      <ModalPopup
        open={true}
        onClose={handleClose}
        title={title}
        width="w-[500px]"
        actionButton={
          <Button onClick={handleClose}>Close</Button>
        }
      >
      {/* main content */}
      <p className="text-gray-700">{content}</p>

      {data?.message && stack && (
        <div className="mt-4">
          <p className="text-sm text-muted-foreground font-semibold">Details:</p>
          <pre className="bg-gray-100 p-2 mt-2 rounded text-xs whitespace-pre-wrap">
            {JSON.stringify(error, null, 2)}
          </pre>
        </div>
      )}
    </ModalPopup>
  );
}

// In production, for other errors, show nothing
return null;
}
